import { Route } from '@angular/router';

import { PERMISSIONS } from '~/app/domains/authorisation/constants/permissions.constants';
import { AuthenticationGuard } from '~/app/domains/authentication/routing/authentication.guard';
import { PublicAuthenticationGuard } from '~/app/domains/authentication/routing/public-authentication.guard';
import { ssoGuard } from '~/app/domains/authentication/routing/sso.guard';
import { AuthorisationGuard } from '~/app/domains/authorisation/routing/authorisation.guard';
import { checkFeatureEnabledGuard } from '~/app/routing/guards/check-feature-enabled/check-feature-enabled.guard';
import { GuestGuard } from '~/app/routing/guards/guest/guest.guard';
import { initGuard } from '~/app/routing/guards/init/init.guard';
import { initUnauthenticatedGuard } from '~/app/routing/guards/init-unauthenticated/init-unauthenticated.guard';


import { FeatureFlag } from './domains/configuration/enums/feature-flag.enum';
import { profileResolver } from '~/app/domains/authentication/routing/profile.resolver';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

export const ROUTES: Route[] = [
    {
        path: '',
        redirectTo: 'shares',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () => import('~/app/domains/authentication/routes'),
        canActivate: [
            initUnauthenticatedGuard,
            GuestGuard,
        ],
    },
    {
        path: 'callback',
        loadChildren: () => import('~/app/domains/consent/routing/routes'),
    },
    {
        path: '',
        canActivate: [ssoGuard],
        children: [
            {
                path: '',
                component: MainLayoutComponent,
                canActivate: [
                    initGuard,
                ],
                children: [
                    {
                        path: '',
                        canActivate: [PublicAuthenticationGuard],
                        children: [
                            {
                                path: 'shares',
                                loadChildren: () => import('~/app/domains/shares/routes'),
                            },
                            {
                                path: 'profile',
                                resolve: { profile: profileResolver},
                                loadComponent: () => import('~/app/domains/profile/features/profile.component')
                                    .then(m => m.ProfileComponent),
                            },
                        ],
                    },
                    {
                        path: '',
                        canActivate: [AuthenticationGuard],
                        children: [
                            {
                                path: 'contacts',
                                loadChildren: () => import('~/app/domains/contacts/routes'),
                            },
                            {
                                path: 'portfolios',
                                loadChildren: () => import('~/app/domains/portfolios/routes'),
                                data: {
                                    featureFlag: FeatureFlag.TECH_FRONT_PORTFOLIO_ENABLE,
                                    permissions: [PERMISSIONS.PORTFOLIO_MODULE_ACCESS],
                                    portfolioContext: 'model',
                                },
                                canActivate: [checkFeatureEnabledGuard, AuthorisationGuard],
                            },
                        ],
                    },

                ],
            },
        ],
    },
    {
        path: 'unauthorised',
        data: {
            errorCode: '403',
        },
        loadComponent: () => import('~/app/shared/components/layouts/not-found/error.component').then(m => m.ErrorComponent),
    },
    {
        path: '**',
        loadComponent: () => import('~/app/shared/components/layouts/not-found/error.component').then(m => m.ErrorComponent),
    },
];
